import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  masterScopeProduction: null,
  masterScopeAftermarket: null,
  disabledSideName: null,
  selectedScopeUnits: null,
  scopeDirty: false,
  selectedScopeViewList: null,
  scopeType: null,
  scopeInvalidError: null
};

const scopeSlice = createSlice({
  name: 'scope',
  initialState,
  reducers: {
    setSelectedScopeUnits: (state, action) => {
      state.selectedScopeUnits = action.payload;
    },
    setMasterScopeProduction: (state, action) => {
      state.masterScopeProduction = action.payload;
    },
    setMasterScopeAftermarket: (state, action) => {
      state.masterScopeAftermarket = action.payload;
    },
    setDisabledSideName: (state, action) => {
      state.disabledSideName = action.payload;
    },
    setScopeDirty: (state, action) => {
      state.scopeDirty = action.payload;
    },
    setSelectedScopeViewList: (state, action) => {
      state.selectedScopeViewList = action.payload;
    },
    setScopeType: (state, action) => {
      state.scopeType = action.payload;
    },
    setScopeInvalidError: (state, action) => {
      state.scopeInvalidError = action.payload;
    },
    hydrateScope: (state, action) => {
      const {
        scopeType = null,
        selectedScopeViewList = null,
        selectedScopeUnits = null
      } = action.payload ?? {};
      state.scopeType = scopeType;
      state.selectedScopeViewList = selectedScopeViewList;
      state.selectedScopeUnits = selectedScopeUnits;
      state.scopeInvalidError = null;
    },
    resetScopeState: () => initialState
  }
});

export const {
  setSelectedScopeUnits,
  setMasterScopeProduction,
  setMasterScopeAftermarket,
  setDisabledSideName,
  setScopeDirty,
  setSelectedScopeViewList,
  setScopeType,
  setScopeInvalidError,
  hydrateScope,
  resetScopeState
} = scopeSlice.actions;

export const selectMasterScopeProduction = (state) =>
  state.scope.masterScopeProduction;
export const selectMasterScopeAftermarket = (state) =>
  state.scope.masterScopeAftermarket;
export const selectDisabledSideName = (state) => state.scope.disabledSideName;
export const selectSelectedScopeUnits = (state) =>
  state.scope.selectedScopeUnits;
export const selectScopeDirty = (state) => state.scope.scopeDirty;
export const selectSelectedScopeViewList = (state) =>
  state.scope.selectedScopeViewList;
export const selectScopeType = (state) => state.scope.scopeType;
export const selectScopeInvalidError = (state) =>
  state.scope.scopeInvalidError;

export const scopeReducer = scopeSlice.reducer;
